export interface GameReward {
    claimed: boolean;
    seconds_until_next_claim: number;
    next_claim_available_at: string | null;
}

export interface RewardsStatusData {
    status: boolean;
    games: {
        welcome: GameReward;
        daily: GameReward;
        weekly: GameReward;
        monthly: GameReward;
    };
}

export interface ClaimRewardResponse {
    status: boolean;
    message: string;
    reward?: number;
    current_points?: number;
    next_claim_available_at?: string;
    seconds_until_next_claim?: number;
}

export type GameType = 'welcome' | 'daily' | 'weekly' | 'monthly';

// Format seconds into human-readable time string
export const formatTimeUntilClaim = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (days > 0) return `${days} ${days === 1 ? 'day' : 'days'}`;
    if (hours > 0) return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    if (minutes > 0) return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    return 'less than a minute';
};